import React from 'react';
import { MILAN_PHONE, NO_RAZOR } from '../../utils/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';

// export const ClaimSuccess = ({ coupon }) => (
//     <div className="text-center pt-4">
//         <p className="p-subhead mb-3">
//             You’ve successfully claimed your{' '}
//             <strong>
//                 <span className="milan-text-primary">{coupon.fetchedData.discount}%</span>
//             </strong>
//             &nbsp;discount.
//         </p>
//         <p className="px-xl-5">
//             You should receive an email from us shortly confirming your discount through{' '}
//             <strong>{new Date(coupon.fetchedData.expDate.toDate()).toString().slice(0, 15)}</strong>
//         </p>
//     </div>
// );

export const ClaimInfoCard = ({ coupon }) => (
    <div className="info-card milan-bg-white mb-3 p-3" style={{ borderRadius: '16px', border: '1px solid #e3f2f2' }}>
        <div className="info-icon mb-3" style={{ textAlign: 'center' }}>
            <FontAwesomeIcon
                icon={faClock}
                style={{
                    fontSize: '2rem',
                    opacity: 0.8,
                }}
                className="milan-text-primary"
            />
        </div>
        <p style={{ textAlign: 'center', fontSize: '1rem', color: '#555', lineHeight: '1.6', margin: 0 }}>
            You’ve successfully claimed your{' '}
            <strong>
                <span className="milan-text-primary">{coupon.fetchedData.discount}%</span>
            </strong>
            &nbsp;discount.
            <br />
            <small>
                You should receive an email from us shortly confirming your discount through <br />
                <strong className="milan-text-primary">
                    {new Date(coupon.fetchedData.expDate.toDate()).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                    })}
                </strong>
            </small>
        </p>
    </div>
);

export const ConsultSuccess = ({ coupon }) => (
    <div className="text-center pt-4">
        <h2 className="milan-text-primary subheadlg pb-0">Thank You!</h2>
        <h2 className="milan-text-tur subheadsm">We'll be in touch.</h2>
        <h6 className="py-3">
            You’ve successfully requested a consult with{' '}
            <strong>
                <span className="milan-text-primary">{coupon.fetchedData.discount}%</span>
            </strong>
            &nbsp;discount.
        </h6>
        <p className="px-xl-4">
            Our team is excited to help you get the smooth, hair-free skin that you deserve! We will be reaching out to
            you shortly to schedule a convenient time for you to come in for your free consultation. In the meantime, if
            you have any questions please contact us at{' '}
            <a href={`tel:${MILAN_PHONE}`} className="milan-text-primary">
                {NO_RAZOR}
            </a>
        </p>
    </div>
);
